<form [formGroup]="checkboxForm">
  <ol type="{{listType}}">

    <prism-ui-form-field-select
      key-id="checkboxesKey"
      [form-field-items-count]="levelTwoQuestions.length"
      [isValid]="formControlUtilitiesService.setCheckboxFormValid(checkboxForm, selectedMaximum)"
      hide-legend="true"
      >
      @if (checkboxForm.hasError('requireCheckboxesToBeChecked')) {
        <span slot="error">{{ diagnosisElement?.error }}</span>
      }
      @if (checkboxForm.hasError('aboveMaxCheckboxesToBeChecked')) {
        <span slot="error">{{ diagnosisMaxLimitElement?.error }}</span>
      }
    </prism-ui-form-field-select>

    @for (check of levelTwoQuestions; track check; let  i = $index) {
      @if (showNumbers) {
        <div class="sameLine">
          <prism-ui-checkbox
            formControlName="{{check.key}}"
            [formGroup]="checkboxForm"
            key-id="{{check.key}}"
            labelText=""
            ngDefaultControl
            [checked]="checkboxForm.get(check.key)?.value === true || checkboxForm.get(check.key)?.value === 'true'"
            (prismUiCheckboxOnChange)="formControlUtilitiesService.toggleIndividualCheckbox($event, check.key, checkboxForm)"
            [isValid]="formControlUtilitiesService.setCheckboxFormValid(checkboxForm)"
            [isDisabled]="selectionLimitReached && !checkboxForm.get(check.key).value"
            ></prism-ui-checkbox><prism-ui-copy key-id="checkbox-label-numbered-{{i}}" copyText="{{check?.label}}"><p class="moveUp" [innerHTML]="check?.label"></p></prism-ui-copy>
          </div>
        }
        @if (!showNumbers) {
          <div class="sameLine">
            <prism-ui-checkbox
              formControlName="{{check.key}}"
              [formGroup]="checkboxForm"
              key-id="{{check.key}}"
              labelText=""
              ngDefaultControl
              [checked]="checkboxForm.get(check.key)?.value === true || checkboxForm.get(check.key)?.value === 'true'"
              (prismUiCheckboxOnChange)="formControlUtilitiesService.toggleIndividualCheckbox($event, check.key, checkboxForm)"
              [isValid]="formControlUtilitiesService.setCheckboxFormValid(checkboxForm)"
              [isDisabled]="selectionLimitReached && !checkboxForm.get(check.key).value"
              ></prism-ui-checkbox><prism-ui-copy key-id="checkbox-label-{{i}}" copyText="{{check?.label}}"><p class="moveUp" [innerHTML]="check?.label"></p></prism-ui-copy>
            </div>
            <br>
            }
            @if (check.hasChronicAcute && checkboxForm.get(check.key).value === true) {
              <app-chronic-acute [parentForm]="parentForm" [key]="check.key" [levelTwoQuestion]="check"></app-chronic-acute>
            }
            @if (!check.hasChronicAcute && checkboxForm.get(check.key).value === true) {
              <app-additional-details [mhsControl]="check" [parentForm]="parentForm"></app-additional-details>
            }
          }
        </ol>
      </form>